export const PLAYLIST_ROUTE = 'playlists';
export const PLAYLIST_ADMINISTRATION_ROUTE = 'location';

export function getPlaylistAdministrationRoute(id: number | string) {
  return `/${PLAYLIST_ROUTE}/${PLAYLIST_ADMINISTRATION_ROUTE}/${id}`;
}
